import { Fab, Grid, SxProps, Theme, Tooltip, Typography } from "@mui/material";
import IReportFilterCriteria from "../../../../../../../../shared/contracts/IReportFilterCriteria";
import FilterFieldComponent from "../filter-field/filter-filed.component";
import MuiIcon from "../../../../../../../../shared/styles/mui/helpers/mui-icon.helper";

interface IProps {
    containerSx?: SxProps<Theme>;
    showAddNewButton?: boolean;
    listFilters: IReportFilterCriteria[];
    handleAddNewFilterItem: () => void;
    handleEditClick: (filterIndex: number, filterItem: IReportFilterCriteria) => void;
    handleDeleteClick: (filterIndex: number, filterItem: IReportFilterCriteria) => void;
    onFilterValueChange: (filterIndex: number, filterValue: string | null) => void,
}
function FiltersComponent({
    containerSx, showAddNewButton = true,
    listFilters,
    handleAddNewFilterItem,
    handleEditClick,
    handleDeleteClick,
    onFilterValueChange
}: IProps) {

    return (<>
        {listFilters.length === 0 &&
            <Grid item container direction='row' justifyContent='start' alignItems='center'>
                <Typography color='text.secondary' variant='subtitle1' sx={{ textOverflow: 'ellipsis' }}>No filters have been applied. Please click on 'Add New Filter' button to apply filters.</Typography>
            </Grid>}
        {listFilters.length > 0 && <Grid sx={containerSx} container direction='row' wrap='wrap' justifyContent='start'
            columnSpacing={2} rowSpacing={2} alignItems='center' paddingBottom={2}>
            {listFilters.map((filter, filterIndex) =>
                <Grid key={`${filter.column}-${filterIndex}`} item xs={3.8}>
                    <FilterFieldComponent filterIndex={filterIndex} filterCriteria={filter}
                        onEditClick={handleEditClick} onDeleteClick={handleDeleteClick} onFilterValueChange={onFilterValueChange} />
                </Grid>
            )}
        </Grid>}

        {showAddNewButton && <Tooltip title='Add New Filter' placement='top-end'>
            <Fab onClick={handleAddNewFilterItem} color='info'>
                {MuiIcon.ADD()}
            </Fab>
        </Tooltip>}

    </>
    );
}
export default FiltersComponent;